import React from 'react';

interface IInitialsAvatarProps
{
	name: string;
	style?: React.CSSProperties;
}

export default function InitialsAvatar(props: IInitialsAvatarProps)
{
	const displayName = props.name || "User";

	return (
		//CSS based on: https://codepen.io/AllThingsSmitty/pen/dWmmQp
		<div data-name={"initials-avatar-" + displayName}
			className={"initialsAvatar"}
			style={props.style}
		>
			<span className="initials">{displayName.split(" ").map(s=>s[0]).join('')}</span>
		</div>
	);
}